function TopicControlRegistrationRequest() {

}

module.exports = TopicControlRegistrationRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/topic-control-registration-request.js
// module id = 482
// module chunks = 1